export default "__VITE_ASSET__CGLp_x2A__"